import { render, staticRenderFns } from "./Notfound.vue?vue&type=template&id=0a26ed5b&scoped=true&"
import script from "./Notfound.vue?vue&type=script&lang=js&"
export * from "./Notfound.vue?vue&type=script&lang=js&"
import style0 from "./Notfound.vue?vue&type=style&index=0&id=0a26ed5b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a26ed5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
